import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Conversaciones que empiezan sobre un tema y terminan en reclamos.', 'No sabés cómo plantear una propuesta sin sonar autoritaria.', 'No encontrás un punto intermedio cuando los dos quieren cosas diferentes.', 'Cada acuerdo se olvida o se reinterpreta después.', 'Sensación de estar sola en las decisiones del cuidado.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-84" data-mp="21zctmhr5g5o6">
      <div className="mx-auto max-w-4xl" data-id="element-85" data-mp="220o0iqfw5tji">
        <header className="text-center" data-id="element-86" data-mp="1nztqy4h3xmj9">
          <h2 className="font-display text-3xl font-bold sm:text-5xl" data-id="element-87" data-mp="1o0vayyg3pjd4">
            ¿Cuántas veces más vas a terminar en discusión?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-88" data-mp="3idl6fkm4b0mm">
            Sos una cuidadora que lo da todo. Pero cada vez que intentás hablar sobre
            algo del cuidado, terminás en una discusión que te agota.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-89" data-mp="1yzvl3o3bazx3">
            El problema no es tu esfuerzo. Es que te faltaba un método para conversar.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-90" data-mp="27sqn88xhgfin">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-91" data-mp="23rdgzxqhaab7" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-92" data-mp="1p3abepgcl0mx" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-93" data-mp="1k2mnwdrbv1xg">
                {point}
              </p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-94" data-mp="2vj2xvrk44qcx">
          ¿Y si pudieras conversar sin terminar agotada desde mañana mismo?
        </p>
      </div>
    </section>;
}